((Drupal, once) => {
  const COOLDOWN_SECONDS = 60;
  const FEEDBACK_VISIBLE_MS = 4000;
  const PENDING_MAX_AGE_MS = 30000;
  const STORAGE_KEY_COOLDOWN_UNTIL = 'veolia:tfa-email-otp:cooldown-until';
  const STORAGE_KEY_PENDING_RESEND = 'veolia:tfa-email-otp:pending-resend';
  const LABEL_RESEND = Drupal.t('Resend');
  const LABEL_CODE_RESENT = Drupal.t('Code resent');

  const getButtonText = (button) => (button.textContent || '').trim();

  const isSendButton = (button) => {
    const value = (button.value || '').trim().toLowerCase();
    const text = getButtonText(button).toLowerCase();
    return value === 'send' || text === 'send';
  };

  const isResendButton = (button) => {
    const value = (button.value || '').trim().toLowerCase();
    const text = getButtonText(button).toLowerCase();
    return value === 'resend' || text === 'resend';
  };

  const setLinkActive = (link) => {
    link.disabled = false;
    link.classList.remove('is-disabled');
    link.textContent = LABEL_RESEND;
  };

  const setLinkCooldown = (link, seconds) => {
    link.disabled = true;
    link.classList.add('is-disabled');
    link.textContent = Drupal.t('Resend (@seconds)', { '@seconds': `${seconds}s` });
  };

  const setCooldownUntil = (seconds) => {
    window.sessionStorage.setItem(
      STORAGE_KEY_COOLDOWN_UNTIL,
      String(Date.now() + (seconds * 1000)),
    );
  };

  const clearCooldownUntil = () => {
    window.sessionStorage.removeItem(STORAGE_KEY_COOLDOWN_UNTIL);
  };

  const getRemainingCooldownSeconds = () => {
    const until = Number(window.sessionStorage.getItem(STORAGE_KEY_COOLDOWN_UNTIL));
    if (!Number.isFinite(until)) {
      return 0;
    }
    return Math.max(0, Math.ceil((until - Date.now()) / 1000));
  };

  const setPendingResend = () => {
    window.sessionStorage.setItem(STORAGE_KEY_PENDING_RESEND, String(Date.now()));
  };

  const consumePendingResend = () => {
    const pendingAt = Number(window.sessionStorage.getItem(STORAGE_KEY_PENDING_RESEND));
    window.sessionStorage.removeItem(STORAGE_KEY_PENDING_RESEND);

    if (!Number.isFinite(pendingAt)) {
      return false;
    }

    return (Date.now() - pendingAt) <= PENDING_MAX_AGE_MS;
  };

  Drupal.behaviors.veoliaTfaEmailOtpResend = {
    attach(context) {
      once('veolia-tfa-email-otp-resend', 'form[data-drupal-selector="tfa-entry-form"]', context)
        .forEach((form) => {
          const sendButton = form.querySelector('[data-drupal-selector="edit-send"]');
          if (!sendButton) {
            return;
          }

          const codeItem = form.querySelector('.form-item-code');
          const resendRow = document.createElement('div');
          resendRow.className = 'tfa-resend-row';

          const feedback = document.createElement('div');
          feedback.className = 'valid-feedback tfa-resend-feedback';
          feedback.textContent = LABEL_CODE_RESENT;

          const resendLink = document.createElement('button');
          resendLink.type = 'button';
          resendLink.className = 'cta-link-small tfa-resend-link';
          resendLink.setAttribute('aria-live', 'polite');

          resendRow.appendChild(feedback);
          resendRow.appendChild(resendLink);

          if (codeItem) {
            codeItem.insertAdjacentElement('afterend', resendRow);
          } else {
            sendButton.parentNode.insertBefore(resendRow, sendButton);
          }

          sendButton.classList.add('tfa-resend-native');
          sendButton.hidden = true;

          let cooldownTimer;

          const showCodeSentFeedback = () => {
            feedback.classList.add('is-visible');
            window.setTimeout(() => {
              feedback.classList.remove('is-visible');
            }, FEEDBACK_VISIBLE_MS);
          };

          const stopCooldown = () => {
            if (cooldownTimer) {
              window.clearInterval(cooldownTimer);
              cooldownTimer = null;
            }
          };

          const refreshCooldownUI = () => {
            const secondsLeft = getRemainingCooldownSeconds();
            if (secondsLeft <= 0) {
              clearCooldownUntil();
              stopCooldown();
              setLinkActive(resendLink);
              return false;
            }
            setLinkCooldown(resendLink, secondsLeft);
            return true;
          };

          const startOrResumeCooldown = (seconds = null) => {
            if (Number.isFinite(seconds) && seconds > 0) {
              setCooldownUntil(seconds);
            }

            const active = refreshCooldownUI();
            if (!active) {
              return;
            }

            stopCooldown();
            cooldownTimer = window.setInterval(refreshCooldownUI, 1000);
          };

          resendLink.addEventListener('click', () => {
            if (resendLink.disabled) {
              return;
            }

            setPendingResend();
            startOrResumeCooldown(COOLDOWN_SECONDS);
            sendButton.click();
          });

          if (isSendButton(sendButton)) {
            setLinkActive(resendLink);
            startOrResumeCooldown(COOLDOWN_SECONDS);
            sendButton.click();
            return;
          }

          if (isResendButton(sendButton)) {
            if (consumePendingResend()) {
              showCodeSentFeedback();
            }
            startOrResumeCooldown();
            return;
          }

          if (getRemainingCooldownSeconds() > 0) {
            startOrResumeCooldown();
            return;
          }

          setLinkActive(resendLink);
        });
    },
  };
})(Drupal, once);
